var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardname(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.9375 1.82812C5.6275 1.82812 4.5625 2.89313 4.5625 4.20312C4.5625 5.48812 5.5675 6.52812 6.8775 6.57312C6.9175 6.56812 6.9575 6.56812 6.9875 6.57312C6.9975 6.57312 7.0025 6.57312 7.0125 6.57312C7.0175 6.57312 7.0175 6.57312 7.0225 6.57312C8.3025 6.52812 9.3075 5.48812 9.3125 4.20312C9.3125 2.89313 8.2475 1.82812 6.9375 1.82812Z",
    fill: "#A9A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47797 7.90258C8.08297 6.97258 5.80797 6.97258 4.40297 7.90258C3.76797 8.32758 3.41797 8.90258 3.41797 9.51758C3.41797 10.1326 3.76797 10.7026 4.39797 11.1226C5.09797 11.5926 6.01797 11.8276 6.93797 11.8276C7.85797 11.8276 8.77797 11.5926 9.47797 11.1226C10.108 10.6976 10.458 10.1276 10.458 9.50758C10.453 8.89258 10.108 8.32258 9.47797 7.90258Z",
    fill: "#A9A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardname);
export default __webpack_public_path__ + "static/media/Cardname.b29f301d05785a361da218f5e633f40f.svg";
export { ForwardRef as ReactComponent };